/**
 * AppShell — desktop-first (≥1280px) shell with lateral SideNav + main content area.
 * Wraps the tutor and admin spaces.
 */

import { Outlet } from 'react-router-dom';
import SideNav from './SideNav';

/**
 * @param {Object} props
 * @param {'tutor'|'admin'} props.role
 */
const AppShell = ({ role }) => {
  return (
    <div className="min-h-screen flex bg-gray-50">
      <SideNav role={role} />

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0">
        {/* Top header bar */}
        <header className="h-14 bg-white border-b border-gray-200 flex items-center px-6 shrink-0">
          <span className="font-montserrat text-sm text-gray-500">
            {role === 'admin' ? 'Administration' : 'Espace répétiteur'}
          </span>
        </header>

        {/* Page content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AppShell;
